import React, { Component } from "react";
import {
  Col,
  Row,
  Container,
  Card,
  CardHeader,
  Input,
  Button,
} from "reactstrap";

import config from "../../config";
import RequestManager from "../../singletons/RequestManager";
export default class AddStaff extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone: "",
      OTPReceived: false,
      otp: "",
      authToken: "",
    };
  }

  componentDidMount() {}

  render() {
    return (
      <Container fluid style={{ padding: 0, margin: 0 }}>
        <Row noGutters>
          <Col>
            <Card>
              <CardHeader>
                <Container fluid>
                  <Row>
                    <Col
                      xs="12"
                      sm="12"
                      md="4"
                      lg="4"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <h5>{"Add Staff"}</h5>
                    </Col>
                  </Row>
                </Container>
              </CardHeader>

              <Col
                xs="12"
                style={{
                  margin: 10,
                  display: "flex",
                }}
              >
                <Input
                  style={{
                    marginRight: 10,
                    padding: 3,
                    fontSize: 20,
                  }}
                  placeholder="Enter phone number"
                  type="number"
                  onChange={this.handleChangePhone}
                />
                <Button
                  color={"primary"}
                  onClick={() => {
                    this.generateOTP();
                  }}
                >
                  {"Send OTP"}
                </Button>
              </Col>
              {this.state.OTPReceived === true ? (
                <Col
                  xs="12"
                  style={{
                    margin: 10,
                    display: "flex",
                  }}
                >
                  <Input
                    style={{
                      marginRight: 10,
                      padding: 3,
                      fontSize: 20,
                    }}
                    placeholder="Enter otp"
                    type="number"
                    onChange={this.handleChangeOTP}
                  />
                  <Button
                    color={"primary"}
                    onClick={() => {
                      this.verifyOTP();
                    }}
                  >
                    {"Verify OTP"}
                  </Button>
                </Col>
              ) : null}
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  generateOTP = async () => {
    try {
      console.log("phone", this.state.phone.length);
      if (this.state.phone.length === 10) {
        this.setState({ phoneNumberConfirmed: true });
        let response = await fetch(
          config.getHost() + "/api/account/otp-generate",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              phone: "+91" + this.state.phone,
            }),
          }
        );
        let responseJSON = await response.json();

        if (responseJSON.success === true) {
          this.setState({ OTPReceived: true });
        } else {
          this.setState({ phoneNumberConfirmed: false });
          alert("Please ensure you've entered a valid phone number");
        }
      } else {
        alert("Please enter a valid phone number.");
      }
    } catch (error) {
      alert("Something went wrong, try again");
      console.log("OTP error", error);
      this.setState({
        phoneNumberConfirmed: false,
        OTPReceived: false,
        otpVerified: false,
        otpConfirmed: false,
      });
    }
  };

  verifyOTP = async () => {
    try {
      if (this.state.otp.length > 3) {
        this.setState({ otpConfirmed: true });
        console.log(
          "params",
          JSON.stringify({
            phone: this.state.phone,
            otp: this.state.otp,
          })
        );
        let response = await fetch(
          config.getHost() + "/api/account/otp-verify",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              phone: "+91" + this.state.phone,
              otp: this.state.otp,
            }),
          }
        );

        let responseJSON = await response.json();
        console.log("responseJSON", JSON.stringify(response));
        if (responseJSON.success === true) {
          console.log("Auth token", responseJSON.token);
          this.setState({ authToken: responseJSON.token });
          this.getUserProfileStaff(responseJSON.token);
        } else {
          this.setState({ otpVerified: false, otpConfirmed: false });
          alert("Please check the OTP recieved or try again.");
        }
      } else {
        alert("Please enter a valid 6 digit OTP.");
      }
    } catch (error) {
      alert(error.message);
    }
  };

  getUserProfileStaff = async (authToken) => {
    let requestManager = new RequestManager();
    let response = await requestManager.getResponseForStaff(
      "getUserProfileStaff",
      {},
      authToken
    );
    console.log("getUserProfileStaff", JSON.stringify(response));
    if (response.error === null) {
      await localStorage.setItem(
        "userProfileStaff",
        JSON.stringify(response.data)
      );
      this.updateUserProfile(response.data);
    } else {
      // call user creation
    }
  };

  updateUserProfile = async (data) => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));

    let params = {
      input: {
        userId: data.userProfile.id,
        storeId: storeInformation.store.id,
        role: "store_manager",
      },
    };
    let requestManager = new RequestManager();

    let response = await requestManager.getResponseFromPredefinedQuery(
      "updateUserProfile",
      params,
      this.state.authToken
    );
    console.log("updateUserProfile", JSON.stringify(response));
    if (response.error === null) {
      alert("successfully added.");
    }
  };

  handleChangePhone = (event) => {
    this.setState({ phone: event.target.value });
  };
  handleChangeOTP = (event) => {
    this.setState({ otp: event.target.value });
  };
}



// WEBPACK FOOTER //
// ./src/pages/AddStaff/AddStaff.js